// extracted by mini-css-extract-plugin
export default {"root":"m1aoy__root Z3kBD__controlRoot","smallSizePlayer":"TEksu__smallSizePlayer"};